module.exports = __webpack_public_path__ + "assets/img/icon.ea377b2b.svg";